import { CommCardFwUpdateInfo } from './comm-card-fw-update-info.model';
import { DependentDeviceFwUpdateInfo } from './dependent-device-fw-update-info.model';

export class ControllerFwUpdateInfo extends DependentDeviceFwUpdateInfo
{
    constructor(json: any = null)
    {
        super(json);

        if (json)
        {
            if (json.CommCard) this.CommCard = new CommCardFwUpdateInfo(json.CommCard);
        }
    }

    CommCard: CommCardFwUpdateInfo;
}
